<div class="book-online-section">
  <p>
    @if (!showForm) {
      <button
        class="online-book-button"
        (click)="showForm = true">
        {{ "Book This Tour Online" | translate }}
      </button>
    }
    @if (showForm) {
      <button
        class="online-book-button"
        (click)="showForm = false">
        {{ "Hide Form" | translate }}
      </button>
    }
  </p>

  @if (showForm) {
    @if (tourId) {
      <p class="tour-book-title">{{ "Book tour online" | translate }}</p>
    }
    @if (toursId) {
      <p class="tour-book-title">{{ "Book tours online" | translate }}</p>
    }
    <app-form [tourId]="tourId" [toursId]="toursId"/>
  }
</div>

